module.exports = __webpack_public_path__ + "static/media/cigar_bands.9b297a8e.jpg";